import { Component, Inject, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { MatTableModule } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { downloadBase64File } from '../../../shared/utils/download_base64'

@Component({
  selector: 'modal-import-history',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    MatProgressSpinner,
  ],
  templateUrl: './modal-import-history.component.html',
  styleUrl: './modal-import-history.component.scss',
})
export class ModalImportHistoryComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ModalImportHistoryComponent>,
    private passengerService: PassengerService,
    private snackbar: SnackbarCustomService,
    @Inject(MAT_DIALOG_DATA) public data: { contratoId: any },
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  downloadingLog: any = null
  downloadingExcel: any = null

  displayedColumns = [
    'codigoTg',
    'dataImportacao',
    'nomeResponsavel',
    'totalCompletos',
    'totalIncompletos',
    'totalIgnorados',
    'acoes',
  ]

  ngOnInit() {
    this.loadHistory()
  }

  loadHistory() {
    this.loading = true
    this.passengerService.listPagedImportHistoryByContract(this.data.contratoId, this.page, this.rows).subscribe({
      next: (res: any) => {
        this.itemsList = res.data ?? []
        this.numberRows = res.totalItens ?? this.itemsList.length
      },
      error: () => {
        this.snackbar.error('Não foi possível carregar o histórico de importações.')
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.loadHistory()
  }

  downloadLog(id: number) {
    this.downloadingLog = id
    this.passengerService.downloadImportLog(id).subscribe({
      next: (res: any) => {
        downloadBase64File(res.data.fileContent, res.data.fileName, res.data.type ?? 'text/plain')
      },
      error: () => {
        this.snackbar.error('Não foi possível baixar o log.')
      },
      complete: () => {
        this.downloadingLog = null
      },
    })
  }

  downloadExcel(id: number) {
    this.downloadingExcel = id
    this.passengerService.downloadImportExcel(id).subscribe({
      next: (res: any) => {
        downloadBase64File(
          res.data.fileContent,
          res.data.fileName,
          res.data.type ?? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        )
      },
      error: () => {
        this.snackbar.error('Não foi possível baixar o Excel.')
      },
      complete: () => {
        this.downloadingExcel = null
      },
    })
  }

  close() {
    this.dialogRef.close()
  }
}
